<template>
    <div class="md_content_1 addAndEditExerciseInputBox">
        <div class="md_header">
            <h6 v-if="this.type === 'add'" class="--blue70">{{ $t( 'rehabilitation.add' ) }}</h6>
            <h6 v-if="this.type === 'edit'" class="--blue70">{{ $t( 'rehabilitation.edit' ) }}</h6>
            <span class="md_close pointer" @click="modalClose">
              <img
                  src="/images/union.svg"
                  alt=""
              />
            </span>
        </div>
        <div class="addAndEditExerciseInputBoxSection">
            <table class="table_view mt20 modal_inputBox">
              <caption></caption> <!-- for sonarlint -->
              <th id="" class="hidden"></th> <!-- for sonarlint -->
              <KvTable :items="items"/>
            </table>
            <div class="bottom_btn_2 mt20">
                <a v-if="this.type === 'add'"
                   class="btn blue btn_basics pointer no-drag"
                   @click="validationCheck('add')"
                >
                  {{$t('rehabilitation.assign_exercise')}}
                </a>
                <a v-if="this.type === 'edit'"
                   class="btn blue btn_basics pointer no-drag"
                   @click="validationCheck('save')"
                >
                  {{$t('status.save')}}
                </a>
                <a class="btn red btn_basics pointer no-drag"
                   :class="typeProps === 'add'? '' : 'hidden'"
                   @click="$modal.show('yes-or-no-modal', {questionType:'reset', function: resetInputBox})"
                >
                  {{$t('status.reset_input')}}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import KvTable from '@/components/Table/kvTable';
    import {
      _MODE_KEY_RANGE,
      _DIRECTION_KEY_RANGE,
      _PART_KEY_RANGE,
      _SPEED_KEY_RANGE,
      _EQUIPMENT_KEY_RANGE,
      _ACTIVE_ASSIST_KEY_RANGE,
      _DATETIME_FORMAT,
      // _DEVICE_HEIGHT_KEY_RANGE,
      _ELBOW_METHOD_KEY_RANGE,
      _WRIST_METHOD_KEY_RANGE,
      _KNEE_ANKLE_METHOD_KEY_RANGE,
    } from "@/components/Table/static";
    import * as ENUM from "@/enum/lib";

    export default {
      name: 'InputBox',
      props: ['selectedRowsProps', 'pageInfoProps', 'presetListProps', 'searchKeywordProps', 'typeProps'],
      components: {
        KvTable,
      },
      data() {
        const items = [
          {
            index: 0,
            keyTitle: this.$t('title'),
            keyType: 'DefaultInput',
            class: '',
            keyRange: '',
            values: undefined,
            maxLength: 50,
          }, {
            index: 1,
            keyTitle: this.$t('rehabilitation.equipment'),
            keyType: 'SelectBox',
            class: '',
            keyRange: _EQUIPMENT_KEY_RANGE.keyRange,
            values: _EQUIPMENT_KEY_RANGE.data[ENUM.EQUIPMENT.REBLESS_HOME]
          }, {
            index: 2,
            keyTitle: this.$t('rehabilitation.mode'),
            keyType: 'SelectBox',
            class: '',
            keyRange: _MODE_KEY_RANGE,
            values: undefined
          }, {
            index: 3,
            keyTitle: this.$t('rehabilitation.position'),
            keyType: 'SelectBox',
            class: '',
            keyRange: _PART_KEY_RANGE.keyRange.slice(0, 4),
            values: undefined
          },
          {
            index: 4,
            keyTitle: this.$t('rehabilitation.exercise_method'),
            keyType: 'SelectBox',
            class: '',
            parentClass: 'hidden',
            keyRange: [],
            values: undefined
          },
          {
            index: 5,
            keyTitle: this.$t('rehabilitation.device_height'),
            keyType: 'SelectBox',
            class: '',
            parentClass: 'hidden',
            keyRange: _KNEE_ANKLE_METHOD_KEY_RANGE,
            values: undefined
          },
          {
            index: 6,
            keyTitle: this.$t('rehabilitation.direction'),
            keyType: 'SelectBox',
            parentClass: 'hidden',
            class: '',
            keyRange: _DIRECTION_KEY_RANGE.keyRange,
            values: undefined
          }, { // 더미값
            index: 7,
            keyTitle: '',
            keyType: '',
            parentClass: 'hidden',
            keyRange: '',
            values: ''
          }, {
            index: 8,
            keyTitle: this.$t('rehabilitation.up'),
            keyType: 'UnitSelectBox',
            parentClass: 'hidden',
            tooltip: {
              msg: this.$t('rehabilitation.flexion_tooltip')
            },
            keyRange: _ACTIVE_ASSIST_KEY_RANGE.data,
            values: undefined
          }, {
            index: 9,
            keyTitle: this.$t('rehabilitation.down'),
            keyType: 'UnitSelectBox',
            parentClass: 'hidden',
            tooltip: {
              msg: this.$t('rehabilitation.extension_tooltip')
            },
            keyRange: _ACTIVE_ASSIST_KEY_RANGE.data,
            values: undefined
          }, {
            index: 10,
            keyTitle: this.$t('rehabilitation.speed'),
            keyType: 'UnitSelectBox',
            parentClass: 'hidden',
            tooltip: {
              msg: this.$t('rehabilitation.speed_tooltip')
            },
            keyRange: _SPEED_KEY_RANGE.data,
            values: undefined
          }, {
            index: 11,
            keyTitle: this.$t('rehabilitation.up_delay'),
            keyType: 'NumberInput',
            parentClass: 'hidden',
            values: undefined,
            minValue: 1,
            maxValue: 3600,
            float: 0,
            description: this.$t('rehabilitation.alert_message.up_delay_range'),
          }, {
            index: 12,
            keyTitle: this.$t('rehabilitation.down_delay'),
            keyType: 'NumberInput',
            parentClass: 'hidden',
            values: undefined,
            minValue: 1,
            maxValue: 3600,
            float: 0,
            description: this.$t('rehabilitation.alert_message.down_delay_range'),
          }, {
            index: 13,
            keyTitle: this.$t('rehabilitation.up_max'),
            keyType: 'NumberInput',
            parentClass: 'hidden',
            values: undefined,
            minValue: 1,
            maxValue: 3600,
            float: 0,
            description: this.$t('rehabilitation.alert_message.up_max_range'),
          }, {
            index: 14,
            keyTitle: this.$t('rehabilitation.down_max'),
            keyType: 'NumberInput',
            parentClass: 'hidden',
            values: undefined,
            minValue: 1,
            maxValue: 3600,
            float: 0,
            description: this.$t('rehabilitation.alert_message.down_max_range'),
          }, { // 더미값
            index: 15,
            keyTitle: '',
            keyType: '',
            parentClass: 'hidden',
            keyRange: '',
            values: ''
          }, {
            index: 16,
            keyTitle: this.$t('rehabilitation.minRange') + `(${this.$t('unit.deg')})`,
            keyType: 'NumberInput',
            parentClass: 'hidden',
            keyRange: '',
            values: undefined,
            tooltip: {
              msg: ''
            },
            description: '',
            float: 0,
            maxLength: 3
          }, {
            index: 17,
            keyTitle: this.$t('rehabilitation.maxRange') + `(${this.$t('unit.deg')})`,
            keyType: 'NumberInput',
            parentClass: 'hidden',
            keyRange: '',
            values: undefined,
            tooltip: {
              msg: ''
            },
            description: '',
            float: 0,
            maxLength: 3
          }, {
            index: 18,
            keyTitle: this.$t('rehabilitation.resistance_sensitivity'),
            keyType: 'NumberInput',
            parentClass: 'hidden',
            values: undefined,
            minValue: 1,
            maxValue: 10,
            float: 0,
            description: this.$t('rehabilitation.alert_message.resistance_sensitivity_range'),
          }, {
            index: 19,
            keyTitle: this.$t('rehabilitation.reps'),
            keyType: 'NumberInput',
            parentClass: 'hidden',
            tooltip: {
              msg: this.$t('rehabilitation.count_tooltip')
            },
            keyRange: '',
            values: undefined,
            minValue: 0,
            maxValue: 254,
            unit: this.$t('rehabilitation.reps'),
            float: 0
          }, {
            index: 20,
            keyTitle: this.$t('rehabilitation.time_as_min'),
            keyType: 'NumberInput',
            parentClass: 'hidden',
            tooltip: {
              msg: this.$t('rehabilitation.time_tooltip')
            },
            description: '',
            class: '',
            keyRange: '',
            values: undefined,
            minValue: 0,
            maxValue: 254,
            unit: this.$t('unit.min'),
            float: 0
          }, {
            index: 21,
            keyTitle: this.$t('rehabilitation.set'),
            keyType: 'NumberInput',
            class: '',
            parentClass: 'hidden',
            tooltip: {
              msg: this.$t('rehabilitation.set_tooltip')
            },
            keyRange: '',
            values: 1,
            minValue: 0,
            maxValue: 99,
            unit: this.$t('rehabilitation.set'),
            float: 0
          }, {
            index: 22,
            keyTitle: this.$t('rehabilitation.due_date'),
            keyType: 'SingleDateInput',
            class: '',
            parentClass: 'hidden',
            tooltip: {
              msg: this.$t('rehabilitation.due_date_tooltip')
            },
            keyRange: '',
            componentOptions: {
              minDate: new Date(),
              maxDate: null,
              popoverVisibility: 'focus',
              popoverDirection: 'bottom',
              positionFixed: true
            },
            values: undefined
          }, {
            index: 23,
            keyTitle: this.$t('rehabilitation.additional_notes'),
            keyType: 'TextArea',
            parentClass: ['memo'],
            class: '',
            keyRange: '',
            values: undefined,
            maxLength: 200,
          }
        ];
        return {
          items,
          type: 'add'
        }
      },
      created() {
        this.type = this.typeProps;
      },
      methods: {
        modalClose: function (event) {
          this.pageInfoProps.currentPage = 0;
          this.$emit('resetPresetList');
          this.$emit('resetInputBox');
          this.$emit('resetSearchKeyword');
          this.$modal.hide('add-edit-exercise-modal');
          event?.preventDefault();
          event?.stopPropagation();
        },
        resetInputBox: function () {
          this.$emit('resetInputBox')
        },
        validationCheck(type) {
          this.$emit('validationCheck', type);
        },
        getValue() {
          return new Promise(async (resolve, reject) => {
            const errorFunc = (error) => {
              reject({
                messageType: 'short',
                message: error,
              });
              return false;
            }

            let rangeCheck = false;
            let valueCheck = false;

            let nullCheck = await this._paramNullCheckPromise(this.items)
                .then(() => {
                  return true;
                })
                .catch(errorFunc);

            if (nullCheck)
              valueCheck = await this._paramValueCheckPromise(this.items)
                  .then(() => {
                    return true;
                  })
                  .catch(errorFunc);

            if (nullCheck && valueCheck)
              rangeCheck = await this._paramRangeCheckPromise(this.items)
                  .then(() => {
                    return true;
                  })
                  .catch(errorFunc);

            if (nullCheck && rangeCheck && valueCheck) {
              const setDefaultValue = (values, defaultValue = '') => {
                return values ?? defaultValue;
              }

              const mode = Number(setDefaultValue(this.items[2]?.values?.no, 0));
              const device = setDefaultValue(this.items[1].values.no);
              const position = setDefaultValue(this.items[3].values.no);

              let reqList = {};
              if (device === 1) {
                // rebless
                reqList = {
                  "exerciseGuideMinRom": Number(setDefaultValue(this.items[16]?.values, 0)),
                  "exerciseGuideMaxRom": Number(setDefaultValue(this.items[17]?.values, 0)),
                }
              } else {
                const timeFormat = (secs) => {
                  let hr = Math.floor(secs / 3600);
                  let min = Math.floor((secs - (hr * 3600)) / 60);
                  let sec = Math.floor(secs - (hr * 3600) - (min * 60));

                  return String(hr).padStart(2, '0') + ':' + String(min).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
                }

                reqList = {
                  "exerciseGuideMuscleStiffSensitive": Number(setDefaultValue(this.items[18]?.values, 0)),
                }

                if (mode === 0 || mode === 3) {
                  reqList = {
                    "exerciseGuideFlexionLimitTime": timeFormat(Number(setDefaultValue(this.items[13]?.values, 0))),
                    "exerciseGuideExtensionLimitTime": timeFormat(Number(setDefaultValue(this.items[14]?.values, 0))),
                    ...reqList,
                  }
                } else {
                  reqList = {
                    "exerciseGuideFlexionDelayTime": timeFormat(Number(setDefaultValue(this.items[11]?.values, 0))),
                    "exerciseGuideExtensionDelayTime": timeFormat(Number(setDefaultValue(this.items[12]?.values, 0))),
                    ...reqList,
                  }
                }

                if (position === 3) {
                  reqList = {
                    "exerciseGuideKneeMinRom": Number(setDefaultValue(this.items[16]?.values, 0)),
                    "exerciseGuideKneeMaxRom": Number(setDefaultValue(this.items[17]?.values, 0)),
                    ...reqList,
                  }
                } else {
                  reqList = {
                    "exerciseGuideAnkleMinRom": Number(setDefaultValue(this.items[16]?.values, 0)),
                    "exerciseGuideAnkleMaxRom": Number(setDefaultValue(this.items[17]?.values, 0)),
                    ...reqList,
                  }
                }
              }

              resolve({
                "seqMedicalRelation": undefined,
                "seqDeviceType": setDefaultValue(this.items[1]?.values?.no),
                "exerciseGuide": {
                  "exerciseGuideTitle": setDefaultValue(this.items[0]?.values),
                  "exerciseGuideContext": setDefaultValue(this.items[23]?.values),
                  "exerciseGuideMode": Number(setDefaultValue(this.items[2]?.values?.no, 0)),
                  "exerciseGuideCount": Number(setDefaultValue(this.items[19]?.values, 0)),
                  "exerciseGuideTime": Number(this.moment.duration(Number(setDefaultValue(this.items[20]?.values), 0), 'minutes').asSeconds()),

                  "exerciseGuideSpeed": setDefaultValue(this.items[10]?.values?.no, 0),
                  "exerciseGuideExtension": setDefaultValue(this.items[9]?.values?.no, 0),
                  "exerciseGuideFlexion": setDefaultValue(this.items[8]?.values?.no, 0),
                  "exerciseGuidePosition": setDefaultValue(this.items[3]?.values?.no, 0),
                  "exerciseGuideDirection": setDefaultValue(this.items[6]?.values?.no, 0),
                  "exerciseGuideHandGripType": Number(setDefaultValue(this.items[4]?.values?.no, 0)),
                  "exerciseGuideDeviceLoh": Number(setDefaultValue(this.items[5]?.values?.no, 0)),
                  ...reqList
                },
                "exerciseSet": Number(setDefaultValue(this.items[21]?.values, 1)),
                "exerciseEndDatetime": this.items[22]?.values ? this.moment(this.items[22].values.setHours(0, 0, 0)).format(_DATETIME_FORMAT) : '',
              });
            }
          });
        },
        _paramValueCheckPromise: (data) => {
          return new Promise((resolve, reject) => {
            const setDefaultValue = (values, defaultValue = '') => {
              return values ?? defaultValue;
            }

            let errorMsg = '';
            const exerciseGuideMode = Number(setDefaultValue(data[2]?.values?.no, 0));
            const exerciseGuideMinRom = Number(setDefaultValue(data[16]?.values, 0));
            const exerciseGuideMaxRom = Number(setDefaultValue(data[17]?.values, 0));

            let device = data[1].values.no;
            let position = data[3].values.no;

            if (exerciseGuideMode === 0 || exerciseGuideMode === 1) {
              let minAngle = position === 4 ? _PART_KEY_RANGE.data[position]?.value[device]?.minAngle : 0;
              let minRom = _PART_KEY_RANGE.data[position]?.value[device]?.minRom;
              let maxRom = _PART_KEY_RANGE.data[position]?.value[device]?.maxRom;

              if (exerciseGuideMinRom < minAngle || exerciseGuideMinRom > minRom || exerciseGuideMinRom.toString().includes('e'))
                errorMsg = _PART_KEY_RANGE.data[position]?.value[device]?.wrong_min_range
              else if (exerciseGuideMinRom >= exerciseGuideMaxRom || exerciseGuideMaxRom > maxRom || exerciseGuideMaxRom.toString().includes('e'))
                errorMsg = _PART_KEY_RANGE.data[position]?.value[device]?.wrong_max_range;
              else if ((exerciseGuideMaxRom - exerciseGuideMinRom) < 10)
                errorMsg = 'alert.at_least_over_ten_diff';
            }

            if (errorMsg !== '')
              reject(errorMsg);
            else
              resolve(data);
          })
        },
        _paramRangeCheckPromise: (data) => {
          return new Promise((resolve, reject) => {
            let errorMsg = '';

            const fromToCheck = (values, from, to) => {
              return Number(values) <= from || Number(values) > to;
            };

            const undefinedCheck = (values) => {
              return values === undefined || values === '' || values === null;
            };

            if (!undefinedCheck(data[19]?.values)) {
              if (fromToCheck(data[19]?.values, 0, 254))
                errorMsg = 'rehabilitation.alert_message.count_length_overflow';
            } else if (!undefinedCheck(data[20]?.values)) {
              if (fromToCheck(data[20]?.values, 0, 254))
                errorMsg = 'rehabilitation.alert_message.time_length_overflow';
            }

            if (errorMsg === '' && data[1]?.values.no === 2) {
              if (fromToCheck(data[18]?.values, 0, 10))
                errorMsg = 'rehabilitation.alert_message.resistance_sensitivity_range';
            }

            if (errorMsg === '' && fromToCheck(data[21]?.values, 0, 99))
              errorMsg = 'rehabilitation.alert_message.set_length_overflow';

            if (errorMsg === '' && moment(data[22].values).diff(moment(), 'days') < 0)
              errorMsg = 'rehabilitation.alert_message.due_date_empty';

            if (errorMsg !== '')
              reject(errorMsg);
            else
              resolve(data);
          })
        },
        _paramNullCheckPromise: (data) => {
          return new Promise((resolve, reject) => {
            let errorMsg = '';

            // 00 : 제목
            // 01 : 수행 기기
            // 02 : 모드
            // 03 : 부위 (1:팔꿈치,2:손목,3:무릅,4:발목)
            // 04 : 운동방법[신규], 부위:팔꿈치,손목
            // 05 : 장치높이[신규], 부위:무릅,발목
            // 06 : 방향
            // 07 : ""
            // 08 : 올리다
            // 09 : 내리다
            // 10 : 속도
            // 11 : 올리다 딜레이 "new" - 2022-10-28
            // 12 : 내리다 딜레이 "new" - 2022-10-28
            // 13 : 올리다 한계치 "new" - 2022-10-28
            // 14 : 내리다 한계치 "new" - 2022-10-28
            // 15 : ""
            // 16 : 최저 ROM(°)
            // 17 : 최고 ROM(°)
            // 18 : 저항 민감도 "new" - 2022-10-26
            // 19 : 회
            // 20 : 시간 (분)
            // 21 : 세트
            // 22 : 마감일
            // 23 : 내용

            // 공통 : 1, 7, 15, 23 번 체크 제외
            let checkExceptIndex = [1, 7, 15, 23];
            const device = data[1]?.values?.no;
            const type = data[2]?.values?.no;
            const position = data[3]?.values?.no;

            const undefinedCheck = (values) => {
              return values === undefined || values === null || values === '';
            };

            if (device === 1) {
              // [11, 12, 13, 14, 18] 프로 전용값
              checkExceptIndex = checkExceptIndex.concat([11, 12, 13, 14, 18]);
              // ([19, 20] 별도 체크 둘중에 하나에만 값이 있으면 되서..)
              checkExceptIndex = checkExceptIndex.concat([19, 20]);

              switch (type) {
                case ENUM.EXERCISE_MODE.ACTIVE :
                  checkExceptIndex = checkExceptIndex.concat([10]);
                  break;
                case ENUM.EXERCISE_MODE.PASSIVE :
                  checkExceptIndex = checkExceptIndex.concat([8, 9]);
                  break;
                case ENUM.EXERCISE_MODE.PASSIVE_MEASURE :
                case ENUM.EXERCISE_MODE.ACTIVE_MEASURE :
                default :
                  checkExceptIndex = checkExceptIndex.concat([8, 9, 10, 16, 17]);
                  break;
              }

              switch (position) {
                case ENUM.POSITION.ELBOW :
                case ENUM.POSITION.WRIST :
                  checkExceptIndex = checkExceptIndex.concat(5);
                  break;
                case ENUM.POSITION.KNEE :
                case ENUM.POSITION.ANKLE :
                default :
                  checkExceptIndex = checkExceptIndex.concat(4);
                  break;
              }
            } else if (device === 2) {
              checkExceptIndex = checkExceptIndex.concat([4, 5, 19]);

              switch (type) {
                case ENUM.EXERCISE_MODE.ACTIVE :
                  checkExceptIndex = checkExceptIndex.concat([10, 11, 12]);
                  break;
                case ENUM.EXERCISE_MODE.PASSIVE :
                  checkExceptIndex = checkExceptIndex.concat([8, 9, 13, 14]);
                  break;


                case ENUM.EXERCISE_MODE.ACTIVE_MEASURE :
                  checkExceptIndex = checkExceptIndex.concat([8, 9, 10, 11, 12, 16, 17, 20]);
                  break;
                case ENUM.EXERCISE_MODE.PASSIVE_MEASURE :
                  checkExceptIndex = checkExceptIndex.concat([8, 9, 13, 14, 16, 17, 20]);
                  break;
              }

              switch (position) {
                case ENUM.POSITION.ELBOW :
                case ENUM.POSITION.WRIST :
                  break;
                case ENUM.POSITION.KNEE :
                case ENUM.POSITION.ANKLE :
                default :
                  break;
              }
            }

            data.some((item, index) => {
              if (!checkExceptIndex.includes(index) && undefinedCheck(item.values))
                errorMsg = `rehabilitation.alert_message.required_except_memo`;

              return errorMsg !== '';
            })

            if (
                errorMsg === ''
                && type !== ENUM.EXERCISE_MODE.PASSIVE_MEASURE
                && type !== ENUM.EXERCISE_MODE.ACTIVE_MEASURE
            ) {
              if (undefinedCheck(data[19]?.values) && undefinedCheck(data[20]?.values)) {
                errorMsg = `rehabilitation.alert_message.required_except_memo`;
              }
            }

            if (errorMsg !== '')
              reject(errorMsg);
            else
              resolve(data);
          })
        },
        setComponents(type = this.items[1]?.values?.no, mode = this.items[2]?.values?.no, position = this.items[3]?.values?.no) {
          for (let i = 4; i <= 22; i++) {
            this.items[i].parentClass = 'hidden';
          }

          if (mode === undefined || position === undefined)
            return;

          this.items[6].parentClass = '';
          this.items[22].parentClass = '';

          this.items[16].tooltip.msg = this.$t(_PART_KEY_RANGE.data[position]?.value[type]?.rom);
          this.items[17].tooltip.msg = this.$t(_PART_KEY_RANGE.data[position]?.value[type]?.rom);
          this.items[16].description = this.$t(_PART_KEY_RANGE.data[position]?.value[type]?.wrong_min_range);
          this.items[17].description = this.$t(_PART_KEY_RANGE.data[position]?.value[type]?.wrong_max_range);

          this.items[16].minValue = _PART_KEY_RANGE.data[position]?.value[type]?.minAngle > 0 ? 0 : _PART_KEY_RANGE.data[position]?.value[type]?.minAngle;
          this.items[17].minValue = _PART_KEY_RANGE.data[position]?.value[type]?.minAngle > 0 ? 0 : _PART_KEY_RANGE.data[position]?.value[type]?.minAngle;
          this.items[16].maxValue = _PART_KEY_RANGE.data[position]?.value[type]?.minRom;
          this.items[17].maxValue = _PART_KEY_RANGE.data[position]?.value[type]?.maxRom;

          if (this.items[16].minValue > this.items[16].values || this.items[16].maxValue < this.items[16].values)
            this.items[16].values = undefined;

          if (this.items[17].minValue > this.items[17].values || this.items[17].maxValue < this.items[17].values)
            this.items[17].values = undefined;

          if (type === 1) {
            this.items[20].tooltip = {
              msg: this.$t('rehabilitation.time_tooltip')
            };
            this.items[20].description = undefined;
            this.items[21].parentClass = '';

            switch (mode) {
              case ENUM.EXERCISE_MODE.ACTIVE :
                this.items[8].parentClass = '';
                this.items[9].parentClass = '';
                this.items[10].parentClass = 'hidden';
                this.items[16].parentClass = '';
                this.items[17].parentClass = '';
                this.items[19].parentClass = '';
                this.items[20].parentClass = '';
                break;
              case ENUM.EXERCISE_MODE.PASSIVE :
                this.items[8].parentClass = 'hidden';
                this.items[9].parentClass = 'hidden';
                this.items[10].parentClass = '';
                this.items[15].parentClass = '';
                this.items[16].parentClass = '';
                this.items[17].parentClass = '';
                this.items[19].parentClass = '';
                this.items[20].parentClass = '';
                break;
              case ENUM.EXERCISE_MODE.PASSIVE_MEASURE :
              case ENUM.EXERCISE_MODE.ACTIVE_MEASURE :
                this.items[8].parentClass = 'hidden';
                this.items[9].parentClass = 'hidden';
                this.items[11].parentClass = 'hidden';
                this.items[16].parentClass = 'hidden';
                this.items[17].parentClass = 'hidden';
                this.items[19].parentClass = 'hidden';
                this.items[20].parentClass = 'hidden';
                break;
            }

            switch (position) {
              case ENUM.POSITION.ELBOW :
                this.items[4].parentClass = '';
                this.items[4].keyRange = _ELBOW_METHOD_KEY_RANGE;
                this.items[4].values = this.items[4]?.values?.no !== undefined ? this.items[4]?.values?.trans === _ELBOW_METHOD_KEY_RANGE[this.items[4]?.values?.no - 1]?.trans ? this.items[4]?.values : undefined : undefined;

                this.items[5].parentClass = 'hidden';
                this.items[5].keyRange = [];
                this.items[5].values = undefined;
                break;
              case ENUM.POSITION.WRIST :
                this.items[4].parentClass = '';
                this.items[4].keyRange = _WRIST_METHOD_KEY_RANGE;
                this.items[4].values = this.items[4]?.values?.no !== undefined ? this.items[4]?.values?.trans === _WRIST_METHOD_KEY_RANGE[this.items[4]?.values?.no - 1]?.trans ? this.items[4]?.values : undefined : undefined;

                this.items[5].parentClass = 'hidden';
                this.items[5].keyRange = [];
                this.items[5].values = undefined;
                break;
              case ENUM.POSITION.KNEE :
              case ENUM.POSITION.ANKLE :
                this.items[4].parentClass = 'hidden';
                this.items[4].keyRange = [];
                this.items[4].values = undefined;

                this.items[5].parentClass = '';
                this.items[5].keyRange = _KNEE_ANKLE_METHOD_KEY_RANGE;
                this.items[5].values = this.items[5]?.values?.no !== undefined ? _KNEE_ANKLE_METHOD_KEY_RANGE[this.items[5]?.values?.no] : undefined;
                break;
            }
          } else if (type === 2) {
            this.items[20].tooltip = undefined;
            this.items[20].description = `\xA0`;
            this.items[21].parentClass = 'hidden';
            this.items[21].value = 1;

            switch (mode) {
              case ENUM.EXERCISE_MODE.ACTIVE :
                this.items[7].parentClass = '';
                this.items[8].parentClass = '';
                this.items[9].parentClass = '';
                this.items[11].parentClass = 'hidden';
                this.items[12].parentClass = 'hidden';
                this.items[13].parentClass = '';
                this.items[14].parentClass = '';
                this.items[16].parentClass = '';
                this.items[17].parentClass = '';
                this.items[18].parentClass = '';
                this.items[20].parentClass = '';
                break;
              case ENUM.EXERCISE_MODE.ACTIVE_MEASURE :
                this.items[7].parentClass = '';
                this.items[8].parentClass = 'hidden';
                this.items[9].parentClass = 'hidden';
                this.items[11].parentClass = 'hidden';
                this.items[12].parentClass = 'hidden';
                this.items[13].parentClass = '';
                this.items[14].parentClass = '';
                this.items[16].parentClass = 'hidden';
                this.items[17].parentClass = 'hidden';
                this.items[18].parentClass = '';
                this.items[20].parentClass = '';
                break;
              case ENUM.EXERCISE_MODE.PASSIVE :
                this.items[10].parentClass = '';
                this.items[11].parentClass = '';
                this.items[12].parentClass = '';
                this.items[13].parentClass = 'hidden';
                this.items[14].parentClass = 'hidden';
                this.items[16].parentClass = '';
                this.items[17].parentClass = '';
                this.items[18].parentClass = '';
                this.items[20].parentClass = '';
                break;
              case ENUM.EXERCISE_MODE.PASSIVE_MEASURE :
                this.items[10].parentClass = '';
                this.items[11].parentClass = '';
                this.items[12].parentClass = '';
                this.items[13].parentClass = 'hidden';
                this.items[14].parentClass = 'hidden';
                this.items[16].parentClass = 'hidden';
                this.items[17].parentClass = 'hidden';
                this.items[18].parentClass = '';
                this.items[20].parentClass = '';
                break;
            }

            switch (position) {
              case ENUM.POSITION.ELBOW :
              case ENUM.POSITION.WRIST :
              case ENUM.POSITION.KNEE :
              case ENUM.POSITION.ANKLE :
                this.items[4].parentClass = 'hidden';
                this.items[5].parentClass = 'hidden';
            }
          }
        }
      },
      computed: {
        items_type: function () {
          let a = Object.assign({}, this.items[1].values);
          return a.no;
        },
        items_mode: function () {
          //Mode 의 입력필드를 카피한다. 카피하는 이유는, 만약 단순히 watch로 입력필드를 바꾼다면,
          //watch가 재귀적으로 작동하며 터지게 될것이기 때문에, watch로 입력필드를 보면서, 수정해서는 안된다.
          //따라서, 모드값을 카피해 두고, 변경이 감지되면 로직의 변경을 처리하도록 해야한다.
          let a = Object.assign({}, this.items[2].values);
          return a.no;
        },
        items_position: function () {
          //Position 의 입력필드를 카피한다. 카피하는 이유는, 만약 단순히 watch로 입력필드를 바꾼다면,
          //watch가 재귀적으로 작동하며 터지게 될것이기 때문에, watch로 입력필드를 보면서, 수정해서는 안된다.
          //따라서, Position값을 카피해 두고, 변경이 감지되면 로직의 변경을 처리하도록 해야한다.
          let a = Object.assign({}, this.items[3].values);
          return a.no;
        },
        items_exerciseLimitsData: function () {
          // 운동에 대한 달성정보와 해당 운동 세트의 달성정보는 각각 제한시간과 제한횟수로 나누어져 있음.
          // 각각의 상태에서 시간과 횟수는 동일하게 달성조건으로 취급하나, 동시에 같이 값을 설정할 수 없다.
          // 간단하게 말하자면, 운동 종료 기한은 5분동안 하거나, 5회를 들어올리면 이지, 5분동안 5회를 하라는 설정 따위는 없는것.
          // 따라서 둘의 값을 탐지면서 변경이 발생시 상대 값을 지우는 로직을 요구함.
          let count = Object.assign({}, this.items[19]);
          let time = Object.assign({}, this.items[20]);
          let set = Object.assign({}, this.items[21]);
          let dueDate = Object.assign({}, this.items[22]);
          return {count, time, set, dueDate}
        },
      },
      watch: {
        items_exerciseLimitsData: {
          handler(newVal, oldVal) {
            if (!!newVal.count.values && (newVal.count.values !== oldVal.count.values)) {
              this.items[20].values = null;
            } else if (newVal.time.values !== null && (newVal.time.values !== oldVal.time.values)) {
              this.items[19].values = null;
            }
          }
        },
        items_type(newType) {
          if (newType === 1)
            this.items[2].keyRange = _MODE_KEY_RANGE;
          else if (newType === 2) {
            if (this.items[2]?.values?.no === 2 || this.items[2]?.values?.no === 3)
              this.items[2].values = undefined;

            this.items[2].keyRange = _MODE_KEY_RANGE.slice(0, 2);
          }

          if (newType === 1)
            this.items[3].keyRange = _PART_KEY_RANGE.keyRange.slice(0, 4);
          else if (newType === 2) {
            if (this.items[3]?.values?.no === 1 || this.items[3]?.values?.no === 2)
              this.items[3].values = undefined;

            this.items[3].keyRange = _PART_KEY_RANGE.keyRange.slice(2, 4);
          }

          this.setComponents(newType, undefined, undefined);
        },
        items_mode(newMode) {
          this.setComponents(undefined, newMode, undefined)
        },
        items_position(newPosition) {
          this.setComponents(undefined, undefined, newPosition)
        },
        type(type) {
          if (type === 'edit') {
            const boolCheck = (checkValue, rtnValue) => {
              return checkValue ? rtnValue : undefined;
            };

            const convert = (value) => {
              try {
                const time = value.split(':');

                return time[0] * 60 * 60 + time[1] * 60 + time[2] * 1
              } catch (e) {
                return undefined
              }
            }

            const device = _EQUIPMENT_KEY_RANGE.data[this.selectedRowsProps?.seqDeviceType ?? ENUM.EQUIPMENT.REBLESS_HOME].no;
            const position = this.selectedRowsProps.exerciseGuide.exerciseGuidePosition;

            let item4 = undefined;

            switch (position) {
              case ENUM.POSITION.ELBOW :
                item4 = _ELBOW_METHOD_KEY_RANGE[this.selectedRowsProps.exerciseGuide.exerciseGuideHandGripType - 1 ?? -1];
                break;
              case ENUM.POSITION.WRIST :
              case ENUM.POSITION.KNEE :
              case ENUM.POSITION.ANKLE :
              default :
                item4 = _WRIST_METHOD_KEY_RANGE[this.selectedRowsProps.exerciseGuide.exerciseGuideHandGripType - 1 ?? -1];
                break;
            }

            this.items[0].values = this.selectedRowsProps.exerciseGuide.exerciseGuideTitle;
            this.items[1].values = _EQUIPMENT_KEY_RANGE.data[this.selectedRowsProps?.seqDeviceType ?? ENUM.EQUIPMENT.REBLESS_HOME];
            this.items[2].values = _MODE_KEY_RANGE[this.selectedRowsProps?.exerciseGuide?.exerciseGuideMode ?? -1];
            this.items[3].values = boolCheck(this.selectedRowsProps.exerciseGuide.exerciseGuidePosition, _PART_KEY_RANGE.data[ENUM.POSITION[ENUM.POSITION[this.selectedRowsProps.exerciseGuide.exerciseGuidePosition]]]);
            this.items[4].values = item4;
            this.items[5].values = _KNEE_ANKLE_METHOD_KEY_RANGE[this.selectedRowsProps.exerciseGuide.exerciseGuideDeviceLoh ?? -1];
            this.items[6].values = boolCheck(this.selectedRowsProps.exerciseGuide.exerciseGuideDirection, _DIRECTION_KEY_RANGE.data[ENUM.DIRECTION[ENUM.DIRECTION[this.selectedRowsProps.exerciseGuide.exerciseGuideDirection]]]);

            this.items[8].values = boolCheck(this.selectedRowsProps.exerciseGuide.exerciseGuideFlexion, _ACTIVE_ASSIST_KEY_RANGE.getItemByNo(this.selectedRowsProps.exerciseGuide.exerciseGuideFlexion));
            this.items[9].values = boolCheck(this.selectedRowsProps.exerciseGuide.exerciseGuideExtension, _ACTIVE_ASSIST_KEY_RANGE.getItemByNo(this.selectedRowsProps.exerciseGuide.exerciseGuideExtension));

            this.items[10].values = boolCheck(this.selectedRowsProps.exerciseGuide.exerciseGuideSpeed, _SPEED_KEY_RANGE.getItemByNo(this.selectedRowsProps.exerciseGuide.exerciseGuideSpeed));

            this.items[11].values = convert(this.selectedRowsProps?.exerciseGuide?.exerciseGuideFlexionDelayTime);
            this.items[12].values = convert(this.selectedRowsProps?.exerciseGuide?.exerciseGuideExtensionDelayTime);
            this.items[13].values = convert(this.selectedRowsProps?.exerciseGuide?.exerciseGuideFlexionLimitTime);
            this.items[14].values = convert(this.selectedRowsProps?.exerciseGuide?.exerciseGuideExtensionLimitTime);

            if (device === 1) {
              this.items[16].values = this.selectedRowsProps?.exerciseGuide?.exerciseGuideMinRom ?? 0;
              this.items[17].values = this.selectedRowsProps?.exerciseGuide?.exerciseGuideMaxRom ?? 0;
            } else {
              if (position === 3) {
                this.items[16].values = this.selectedRowsProps?.exerciseGuide?.exerciseGuideKneeMinRom ?? 0;
                this.items[17].values = this.selectedRowsProps?.exerciseGuide?.exerciseGuideKneeMaxRom ?? 0;
              } else {
                this.items[16].values = this.selectedRowsProps?.exerciseGuide?.exerciseGuideAnkleMinRom ?? 0;
                this.items[17].values = this.selectedRowsProps?.exerciseGuide?.exerciseGuideAnkleMaxRom ?? 0;
              }
            }

            this.items[18].values = this.selectedRowsProps?.exerciseGuide?.exerciseGuideMuscleStiffSensitive;

            this.items[19].values = this.selectedRowsProps?.exerciseGuide?.exerciseGuideCount || undefined;
            this.items[20].values = boolCheck(this.selectedRowsProps?.exerciseGuide?.exerciseGuideTime, this.moment.duration(Number(this.selectedRowsProps.exerciseGuide.exerciseGuideTime), 'second').asMinutes());
            this.items[21].values = this.selectedRowsProps?.exerciseSet ?? 1;
            this.items[22].values = boolCheck(this.selectedRowsProps.exerciseEndDatetime, this.moment(this.selectedRowsProps.exerciseEndDatetime).toDate());
            this.items[23].values = this.selectedRowsProps.exerciseGuide.exerciseGuideContext;
          }
        },
      }
    }
</script>
<style lang="scss">
.modal_inputBox {
    .table-container {
        .item-parent:last-child {
            grid-column: 1/3;

            .item-value {
                flex: 7 3 1rem;
            }

            textarea {
                height: 120px;
            }
        }
    }
}

.addAndEditExerciseInputBox {
  display: flex;
  flex-direction: column;

  & .addAndEditExerciseInputBoxSection {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .table-container {
      .item-parent {
        .item-value {
          flex: 2 3 0rem;
        }

        &.memo {
          .item-title {
            max-width: 112.3px;
          }

          .item-value {
            flex: 3 3 0rem;
          }
        }
      }
    }

    & .bottom_btn_2 {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      & a {
        &:nth-child(1) {
          display: inline-block;
          float: left;
        }

        &a:nth-child(2) {
          width: 200px;
          display: inline-block;
          float: right;
        }
      }
    }

    .vs__dropdown-menu {
      max-height: 255px;
    }
  }
}
</style>